export const ARROW_ICON_CLASSNAME = 'JobStatus__ArrowIcon';
